import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-416d69fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "what-we-do" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-light" }, [
  /*#__PURE__*/_createTextVNode(" W "),
  /*#__PURE__*/_createElementVNode("strong", null, "Carspot24"),
  /*#__PURE__*/_createTextVNode(" pomagamy kierowcom rozwiązywać ich problemy ")
], -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "d-flex mt-md col-lg-6 col-12" }
const _hoisted_6 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_7 = { class: "img-in-round" }
const _hoisted_8 = { class: "inline-wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center ms-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-18 m-0" }, [
    /*#__PURE__*/_createTextVNode("Zidentyfikujesz usterkę"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("po objawach")
  ])
], -1))
const _hoisted_10 = { class: "d-flex mt-md col-lg-6 col-12" }
const _hoisted_11 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_12 = { class: "img-in-round" }
const _hoisted_13 = { class: "inline-wrapper" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center ms-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-18 m-0" }, [
    /*#__PURE__*/_createTextVNode(" Sprawdzisz co się zepsuło"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("i jak to naprawić ")
  ])
], -1))
const _hoisted_15 = { class: "d-flex mt-md col-lg-6 col-12" }
const _hoisted_16 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_17 = { class: "img-in-round" }
const _hoisted_18 = { class: "inline-wrapper" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center ms-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-18 m-0" }, [
    /*#__PURE__*/_createTextVNode(" Zweryfikujesz ile powinna"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("kosztować naprawa ")
  ])
], -1))
const _hoisted_20 = { class: "d-flex mt-md col-lg-6 col-12" }
const _hoisted_21 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_22 = { class: "img-in-round" }
const _hoisted_23 = { class: "inline-wrapper" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center ms-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-18 m-0" }, [
    /*#__PURE__*/_createTextVNode(" Eksperci pomogą rozwiązać"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("twój problem z samochodem ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_car_icon = _resolveComponent("car-icon")!
  const _component_wrench_icon = _resolveComponent("wrench-icon")!
  const _component_assignment_icon = _resolveComponent("assignment-icon")!
  const _component_search_file_icon = _resolveComponent("search-file-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_car_icon)
              ])
            ])
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_wrench_icon)
              ])
            ])
          ]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_assignment_icon)
              ])
            ])
          ]),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_search_file_icon)
              ])
            ])
          ]),
          _hoisted_24
        ])
      ])
    ])
  ]))
}